<template>
  <div class="flex flex-col">
    <span class="flex items-center">
      <span>{{ name }}</span>
      <span
        v-if="isLastUsed"
        class="ml-2 rounded bg-gray-100 px-1.5 text-xs text-gray-700"
        >Last used</span
      >
    </span>
    <span
      v-if="expiry"
      class="text-xs"
      :class="isExpired ? 'text-red-500' : 'text-gray-500'"
    >
      {{ isExpired ? "Expired" : "Expires" }} {{ expiry }}
    </span>
  </div>
</template>

<script setup lang="ts">
// Two-line body for stored-card rows in a Select `#option` slot. Row graying
// for expired cards comes from PrimeVue's `option-disabled` (p-disabled), not
// from here. The "Last used" pill is a plain span so it inherits the row's
// disabled styling when the card is also expired.
withDefaults(
  defineProps<{
    name: string;
    expiry: string | null;
    isExpired: boolean;
    isLastUsed?: boolean;
  }>(),
  { isLastUsed: false }
);
</script>
